import { useEffect, useState } from "react";
import {
  getYoutubeChannelList,
  getYoutubeList,
  IYoutube,
  IYoutubeChannel,
} from "../../../../../api/youtube";
import {
  HomeYoutubeHeader,
  HomeYoutubeVideoItem,
  HomeYoutubeVideoItemBurl,
  HomeYoutubeVideoItemContentChannel,
  HomeYoutubeVideoItemContentWrapper,
  HomeYoutubeVideoItemPlayButton,
  HomeYoutubeVideoItemThumbnail,
  HomeYoutubeVideoItemThumbnailImage,
  HomeYoutubeVideoRow,
  HomeYoutubeVideoWrapper,
  HomeYoutubeWrapper,
} from "./styles";
import HomeYoutubeChannel from "./channel";
import YoutubeSkeleton from "./skeleton";
import { openNewWindow } from "../../../../../utils/common";

const HomeYoutube = () => {
  const [list, setList] = useState<IYoutube[]>([]);
  const [channels, setChannels] = useState<IYoutubeChannel[]>([]);
  const [loading, setLoading] = useState(true);

  const getList = async () => {
    try {
      // Promise.all로 병렬 처리하여 성능 개선
      const [youtubeResult, cartoonResult, channelsResult] = await Promise.all([
        getYoutubeList("YOUTUBE"),
        getYoutubeList("CARTOON"),
        getYoutubeChannelList(),
      ]);

      const recommended = youtubeResult
        .concat(cartoonResult)
        .filter((item) => item.recommend)
        .sort((a, b) => {
          return (
            new Date(b.createdAt).getTime() - new Date(a.createdAt).getTime()
          );
        });

      setChannels(channelsResult);
      setList(recommended.slice(0, 3));
    } catch (error) {
      console.error("YouTube 데이터 로드 실패:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 100);
    }
  };

  useEffect(() => {
    getList();
  }, []);

  // 로딩 중일 때 스켈레톤 표시
  if (loading) {
    return <YoutubeSkeleton />;
  }

  return (
    <HomeYoutubeWrapper>
      <HomeYoutubeVideoWrapper>
        <HomeYoutubeHeader>
          홀덤 관련 <span>인기 영상</span>
        </HomeYoutubeHeader>
        <HomeYoutubeVideoRow>
          {list.map((item, index) => (
            <HomeYoutubeVideoItem key={item.id} index={index}>
              <HomeYoutubeVideoItemThumbnail
                onClick={() => {
                  openNewWindow(item.url);
                }}
              >
                <HomeYoutubeVideoItemBurl />
                <HomeYoutubeVideoItemPlayButton index={index}>
                  <img src="/image-web/home/play-button.svg" alt="play" />
                </HomeYoutubeVideoItemPlayButton>
                <HomeYoutubeVideoItemThumbnailImage src={item.thumbnailUrl} />
              </HomeYoutubeVideoItemThumbnail>
              <HomeYoutubeVideoItemContentWrapper>
                <div className="title">{item.title}</div>
                <HomeYoutubeVideoItemContentChannel>
                  <img src={item.youtubeChannel.profileUrl} alt="channel" />
                  <div className="name">{item.youtubeChannel.name}</div>
                </HomeYoutubeVideoItemContentChannel>
              </HomeYoutubeVideoItemContentWrapper>
            </HomeYoutubeVideoItem>
          ))}
        </HomeYoutubeVideoRow>
      </HomeYoutubeVideoWrapper>
      <HomeYoutubeChannel channels={channels} />
    </HomeYoutubeWrapper>
  );
};

export default HomeYoutube;
